import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
import { CheckList } from './CheckList';
import { CtaButton } from './CtaButton';
import { everythingIncluded, optionA, optionB, price, trustBadges } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full border-t border-line bg-canvas py-10 sm:py-20" aria-labelledby="final-cta-heading" data-id="element-87" data-mp="3qrosjgds4fwr">
      <div className="mx-auto max-w-3xl px-5 sm:px-6" data-id="element-88" data-mp="2y53yg85x5ppi">
        <h2 id="final-cta-heading" className="text-center font-display text-2xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-89" data-mp="2y6ow46nj5orl">
          Next week: keep improvising…
          <span className="block text-gold-text" data-id="element-90" data-mp="3820c0saod20x">
            or walk onto the track with your system ready.
          </span>
        </h2>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:mt-8 sm:gap-4" data-id="element-91" data-mp="3cvuuxtighcyy">
          <div className="rounded-2xl border border-line bg-white p-4" data-id="element-92" data-mp="2fdkx05rjmjpl">
            <p className="text-[11px] font-bold uppercase tracking-wider text-body" data-id="element-93" data-mp="2kcnv1693vpo2">
              Option A
            </p>
            <CheckList items={optionA} tone="cross" size="xs" className="mt-3" data-id="element-94" data-mp="2dap0k6o9kyz9" />
          </div>
          <div className="rounded-2xl border border-gold bg-white p-4" data-id="element-95" data-mp="28e88x2huw2hf">
            <p className="text-[11px] font-bold uppercase tracking-wider text-gold-text" data-id="element-96" data-mp="23lp0ejy0zxjh">
              Option B
            </p>
            <CheckList items={optionB} size="xs" className="mt-3" data-id="element-97" data-mp="1ymc8hksas0a1" />
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-gold/60 bg-white p-5 shadow-lg shadow-navy/5 sm:mt-8 sm:p-8" data-id="element-98" data-mp="1uma77cqh58va">
          <h3 className="text-center font-display text-xl font-bold text-navy sm:text-2xl" data-id="element-99" data-mp="1pl4evg0q7nma">
            Everything Included
          </h3>
          <CheckList items={everythingIncluded} columns={2} size="xs" className="mt-4 !grid-cols-2 !gap-x-3 !gap-y-1.5 border-t border-line pt-4" data-id="element-100" data-mp="1fohv6uk4z2lu" />

          <blockquote className="mt-5 text-center text-sm italic leading-relaxed text-body" data-id="element-101" data-mp="3f0u2pmu8vu2k">
            “The best time to have a coaching system was before your athletes
            needed it.{' '}
            <span className="font-bold not-italic text-navy" data-id="element-102" data-mp="18biog4jm6dvu">
              The second best time is today.
            </span>
            ”
          </blockquote>

          <CtaButton size="large" className="mt-5 w-full" data-id="element-103" data-mp="yfp0lp0g2xyr">
            Get the system now — {price}
          </CtaButton>
          <ul className="mt-3 flex flex-wrap justify-center gap-x-3.5 gap-y-1" data-id="element-104" data-mp="13es6tcs5va8b">
            {trustBadges.map(badge => <li key={badge} className="flex items-center gap-1 text-[11px] text-body sm:text-xs" data-id="element-105" data-mp="1r44e273xh87z">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-success" strokeWidth={2.25} aria-hidden="true" data-id="element-106" data-mp="1w25wcptj53ie" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}